import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "container row m-0 py-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Verify Signature")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Before proceeding, enter your signature for given organization in the textbox provided below to confirm that you are authorized to make changes to your company information. ")
], -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 ps-2 pe-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pb-1 mb-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Organization Name")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "pb-1 mb-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Signature"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_9 = { class: "col-7 ps-4 pe-4" }
const _hoisted_10 = { class: "pb-1 mb-2" }
const _hoisted_11 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_12 = {
  key: 0,
  class: "d-flex justify-content-center mb-3 mt-2"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "full-height": false,
    title: "Company Security Setup",
    "application-id": '1',
    "show-background": true,
    "use-gray-theme": true
  }, {
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
        : (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.organizationName), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["form-control", `${!_ctx.v$.signature.$error ? '' : 'field-invalid'}`]),
                  maxlength: "50",
                  name: "organization-name",
                  type: "password",
                  placeholder: "Enter Signature",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signature) = $event)),
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.signature.$touch && _ctx.v$.signature.$touch(...args)))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.signature]
                ]),
                (_ctx.v$.signature.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Please provide your signature before proceeding."))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.isVerifying)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_15))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-md btn-outline-secondary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
                        }, "Cancel"),
                        _createElementVNode("button", {
                          class: "btn btn-primary ms-2",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.verifySignature()))
                        }, "Proceed")
                      ]))
                ]))
              : _createCommentVNode("v-if", true)
          ]))
    ]),
    _: 1 /* STABLE */
  }))
}